// Mensaje de error que devuelve el backend (FastAPI), para mostrarlo en los
// toasts en vez de un texto genérico. FastAPI lo manda como
// `{ detail: "..." }` en las HTTPException, y como `{ detail: [{ msg }] }`
// en los errores de validación (422). Si no hay mensaje utilizable (sin
// respuesta del servidor, página HTML de error del proxy...), se usa el
// texto genérico de siempre.
export const getBackendErrorMessage = (error: any, fallback: string): string => {
  const data = error?.response?.data;
  const detail = data?.detail ?? data?.message;

  if (typeof detail === "string" && detail.trim()) return detail;
  if (Array.isArray(detail)) {
    const messages = detail
      .map((d: any) => (typeof d === "string" ? d : d?.msg))
      .filter(Boolean);
    if (messages.length) return messages.join(". ");
  }
  if (typeof data === "string" && data.trim() && !data.trim().startsWith("<")) {
    return data;
  }
  return fallback;
};

// Para la opción `error` de toast.promise: muestra el mensaje del backend
// del error con el que se rechazó la promesa, o el texto genérico.
export const backendErrorToast = (fallback: string) => ({
  render: ({ data }: { data?: any }) => getBackendErrorMessage(data, fallback),
});
